<template>
  <div class="GlobalFormDemo">
    <GlobalForm :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :inline="true"
      :labelWidth="85" :needBtnLoading="true" round @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item label-width="70px" label="门店商户" slot="contractType" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="companyIds" placeholder="请选择" clearable filterable multiple>
          <el-option v-for="item in goodsStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label-width="'80px'" label="回收分类" slot="typeId" style="margin:0">
        <el-select clearable @change="recoverySeparator" v-model="typeId">
          <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label-width="'80px'" label="回收品牌" slot="brandNo" style="margin:0">
        <el-select clearable filterable v-model="brandNo" @change="recoverySeparator">
          <el-option v-for="item in brandNoListData" :key="item.id" :label="item.name" :value="item.brandNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label-width="'80px'" label="回收商品" slot="phoneName" style="margin:0">
        <el-select placeholder="请先选择分类" filterable :disabled="!typeId" clearable v-model="modelCode">
          <el-option v-for="item in modelListData" :key="item.modelNo" :label="item.name" :value="item.modelNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态" slot="state" style="margin:0" :label-width="'72px'">
        <el-select v-model="state" multiple placeholder="请选择订单状态" clearable>
          <el-option v-for="item in orderStatusList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from select_down" label="开机情况" slot="signatoryId" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="merchantId" placeholder="请选择" clearable>
          <el-option v-for="item in machineType" :key="item.merchantId" :label="item.merchantName"
            :value="item.merchantId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="70px" label="旧机情况" slot="Oldmachinebrand" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="healthCode" placeholder="请选择" clearable filterable>
          <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="70px" label="成色等级" slot="finenessHealthCode" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="finenessHealthCode" placeholder="请选择" clearable filterable
          multiple>
          <el-option v-for="item in levelcolorList" :key="item.value" :label="item.key" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="120px" label="是否比对机型" slot="sku" style="margin: 0">
             <el-cascader v-model="sku" :options="skuList" :show-all-levels="false" collapse-tags clearable :props="props2"
          @change="handleChange1"></el-cascader>
      </el-form-item>
      <el-form-item label-width="120px" label="机型比对情况" slot="sku" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="skuqk" placeholder="请选择" clearable filterable>
          <el-option v-for="item in skuListqk" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="120px" label="开机亮屏照识别" slot="screenPhoto" style="margin: 0">
        <el-cascader v-model="screenPhotos" :options="screenPhotosList" @change="handleChange" :show-all-levels="false"
          :props="props1" collapse-tags clearable></el-cascader>
      </el-form-item>
      <el-form-item label-width="90px" label="是否识图" slot="isAiIdentify" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="isAiIdentify" placeholder="请选择" clearable filterable>
          <el-option v-for="item in recogimgList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="90px" label="识图标签" slot="tagIdList" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="tagIdList" placeholder="请选择" clearable filterable multiple>
          <el-option v-for="item in imglabelList" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="140px" label="是否触发自动报价" slot="isAuto" style="margin: 0">
        <el-select :popper-append-to-body="false" v-model="isAuto" placeholder="请选择" clearable filterable>
          <el-option v-for="item in isAutoList" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="70px" label="故障项" slot="signatoryName" style="margin: 0">
        <el-cascader v-model="failureIds" :options="failureTypeList" @change="handleChange" :show-all-levels="false"
          :props="props" collapse-tags></el-cascader>
        <!-- <el-select
          :popper-append-to-body="false"
          v-model="failureIds"
          placeholder="请选择"
          clearable
          filterable
          multiple
        >
          <el-option
            v-for="item in failureTypeList"
            :key="item.key"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      </el-form-item>
      <!-- <template>
        <el-button
          icon="el-icon-download"
          size="small"
          type="success"
          @click="exportExcel"
          >导出Excel</el-button
        >
      </template> -->
    </GlobalForm>
    <!-- 导出Excel谷歌验证 -->
    <el-dialog title="操作提示" :visible.sync="codeShow" :close-on-click-modal="false" width="500px" @closed="closeExport">
      <div class="cance-tip">
        <div class="tip-sure">是否确认导出订单？</div>
      </div>
      <div class="command">
        <div style="width: 88px">动态口令：</div>
        <el-input v-model="code" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="closeExport">取消</el-button>
        <el-button type="primary" :loading="codeLoading" @click.native="codeSubmit">确定</el-button>
      </span>
    </el-dialog>
    <DialogDownLoad v-if="isShowDownloadSuccess" :isShowDownloadSuccess="isShowDownloadSuccess" @close="closebillDown"
      @config="billconfig"></DialogDownLoad>
  </div>
</template>

<script>
import { formValidateMobile } from "@/utils/form-validate";
import moment from "moment";
import _api from "@/utils/request";
import { MessageBox } from "element-ui";
import DialogDownLoad from "@/components/global/components/DialogDownLoad.vue"
import { _http } from "../../../utils/request/bill";
import { http } from "@/utils/request/compositionRule";
export default {
  name: "Form",
  components: {
    DialogDownLoad
  },
  data() {
    return {
      merchantId: "",
      machineType: [{ merchantId: 'canStart', merchantName: "正常开机" }, { merchantId: 'unStart', merchantName: "无法开机" }, { merchantId: 'brand-new', merchantName: "全新机" }, { merchantId: 'elderly', merchantName: "功能机/老年机" }],
      healthCode: "",
      failureIds: [],
      companyIds: [],
      productList: [{ id: "Nice", name: "靓机" }, { id: "Little_Snow", name: "小花" }, { id: "Big_Snow", name: "大花" }, { id: "Out_Burst", name: "外爆" }, { id: "Inner_Burst", name: "内爆" }, { id: "Other", name: "其他" }],
      levelcolorList: [],
      failureTypeList: [],
      initData: {
        entryTime: [moment().day(moment().day()).format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')]
      },
      goodsStateList: [],
      startTime: "",
      endTime: "",
      pickerMinDate: null,
      pickerMaxDate: null,
      day31: 180 * 24 * 3600 * 1000,
      formItemList: [
        {
          key: "orderNo",
          type: "input",
          labelName: "订单编号",
          placeholder: "请输入订单编号",
          lableWidth: "70px",
        },
        {
          key: "imei",
          type: "input",
          labelName: "串号",
          placeholder: "请输入串号查询",
          lableWidth: "50px",
        },
        {
          key: "orderNoOneline",
          type: "input",
          labelName: "外部订单号",
          placeholder: "请输入外部单号查询",
          lableWidth: "90px",
        },
        { slotName: "contractType" }, //
        { slotName: "typeId" },
        { slotName: "brandNo" },
        { slotName: 'phoneName' },
        { slotName: "state" },

        { slotName: "signatoryId" }, //
        { slotName: "Oldmachinebrand" },
        { slotName: "finenessHealthCode" },
        { slotName: "signatoryName" }, //
        { slotName: "sku" },
        { slotName: "screenPhoto" },
        { slotName: "isAiIdentify" },
        { slotName: 'tagIdList' },
        { slotName: "isAuto" },
        {
          key: "entryTime",
          type: "pickerOptions",
          clearable: true,
          labelName: "下单时间",
          lableWidth: "70px",
          placeholder: "请选择时间",
          valueFormat: "timestamp",

          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate) {
                this.pickerMinDate = null;
              } else if (minDate) {
                this.pickerMinDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate) {
                return (
                  time.getTime() > this.pickerMinDate + this.day31 ||
                  time.getTime() < this.pickerMinDate - this.day31
                );
              }
              return false;
            },
          },
        },

      ],
      formRules: {
        mobile: [
          {
            validator: formValidateMobile,
            trigger: "blur",
          },
        ],
      },
      SeachParams: {},
      codeShow: false, //导出Excel谷歌口令弹框
      code: "",
      codeLoading: false, //导出订单
      isShowDownloadSuccess: false,
      pageNum: 1,
      pageSize: 10,
      typeId: "",
      modelCode: "",
      modelListData: [],
      brandNo: "",
      brandNoListData: [],
      classList: [],
      state: [],
      orderStatusList: [],
      finenessHealthCode: [],
      sku: [],
      skuListqk: [{ id: '01', name: "机型一致" }, { id: '02', name: "机型不一致" }],
      skuList: [{ value: "00", label: "未比对" }, { value: "01", label: "已比对", children: [{ value: "00", label: "3023" }, { value: "01", label: "豆包" }] }],
      isAiIdentify: '',
      recogimgList: [{ id: true, name: "已识图" }, { id: false, name: "未识图/部分失败" }],
      isAutoList: [{ key: true, value: "是" }, { key: false, value: "否" }],
      tagIdList: [],
      imglabelList: [],
      props: { multiple: true, emitPath: false, },
      props1: { multiple: true },
      isAuto: null,
      skuqk: "",
      screenPhotos: [],
      screenPhotosList: [{ value: "00", label: "未识别" }, { value: "01", label: "识别成功", children: [{ value: "01", label: "有亮屏照" }, { value: "02", label: "无亮屏照" }] }, { value: "02", label: "识别失败" },],
            props2: {
        multiple: true,
        checkStrictly: true,

      },
      selectedValues1:[],
      modelCompareType:[],
      modelPlatforms:[],
       selectedValues: [],
    };
  },
  created() {
        http.healthList({ isIncludeRisk: false }).then(res => {
      this.levelcolorList=res.data
    })
    this.getDetectionCategory();
    this.handleConfirm(this.initData)
    _api.getSelectList().then((res) => {
      if (res.code === 1) {
        this.goodsStateList = res.data.map((v) => {
          return {
            label: v.name,
            value: v.id,
          };
        });
      }
    });
    _api.selectList().then(res => {
      console.log(res)
      this.classList = res.data ? res.data : []
    })
    _api.oldBrandSelectList().then((res) => {
      if (res.code === 1) {
        this.brandNoListData = res.data;
      }
    });
    this.getStatusList()
    _api.tagselected().then((res) => {
      console.log(res, "识图标签")
      if (res.code === 1) {
        this.imglabelList = res.data;
      }
    });
  },
  methods: {
    // 获取故障项下拉
    getDetectionCategory() {
      _http.findTreeFailure2().then((res) => {
        console.log(res, "的合格合格符合")
        this.failureTypeList = res.data;
      });
    },
    //查询
    handleConfirm(data, cd) {
      console.log(this.screenPhotos, "screenPhotos")
      console.log(data);
      let startTime = "";
      let endTime = "";
      if (data?.entryTime === null || !data?.entryTime) {
        startTime = "";
        endTime = "";
      } else {
        startTime = Number(moment(data.entryTime[0]).format("x"));
        endTime = Number(moment(data.entryTime[1]).format("x"));
      }
      let arry=[]
        let lsarry=[]
      this.screenPhotos.forEach(item=>{
          if(item[0]){
            arry.push(item[0])
          }
          if(item.length==2){
             lsarry.push(item[1])
          }
      })
      let lightScreenStates = arry.reduce((acc, current) => {
        if (!acc.has(current)) {
          acc.add(current);
        }
        return acc;
      }, new Set());
    
      lightScreenStates = Array.from(lightScreenStates);
      let lightScreenSubStates=lsarry
      console.log(lightScreenSubStates,"lightScreenSubStates")
      const baseRequest = {
        imei: data && data.imei ? data.imei : "",
        orderNo: data && data.orderNo ? data.orderNo : "",
        orderNoOneline: data && data.orderNoOneline ? data.orderNoOneline : "",
        healthCode: this.healthCode,
        failureIds: this.failureIds,
        companyIds: this.companyIds,
        openMachineCondition: this.merchantId,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        typeId: this.typeId,
        brandNo: this.brandNo,
        modelCode: this.modelCode,
        state: this.state,
        finenessHealthCode: null,
        finenessHealthCodes: this.finenessHealthCode,
       modelCompareType:this.modelCompareType[0],
        isAiIdentify: this.isAiIdentify,
        tagIdList: this.tagIdList,
        isAutoQuote: this.isAuto,
        modelCompare: this.skuqk,
        lightScreenStates,
        lightScreenSubStates,
        modelPlatforms:this.modelPlatforms,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      this.SeachParams = baseRequest;
      this.$store.commit("tagsView/SEACH_PARAMS", baseRequest);
    },
    //导出Excel
    exportExcel(e) {
      this.codeShow = true;
    },
    closeExport() {
      this.codeShow = false;
      (this.code = ""), (this.codeLoading = false);
    },
    codeSubmit() {

      if (!this.code) {
        return this.$message.error("请输入谷歌动态码");
      }
      console.log(this.times);
      const params = {
        ...this.SeachParams,
        command: this.code,
      };
      if (!params.startTime) {
        return this.$message.error("请选择导出时间查询");
      }
      this.codeLoading = true;
      console.log(params);
      _http
        .excelFailureOrderMatch(params)
        .then((res) => {
          console.log(res, 9999900000);
          const content = res;
          this.codeShow = false;
          this.code = "";
          const blob = new Blob([content]);
          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            try {
              let data = JSON.parse(reader.result);
              console.log(data, "反对纷纷改行`1")
              if (data.code === 0) {
                this.$message.error(data.msg || "导出失败");
                this.isShowDownloadSuccess = false;
              }
              else {
                console.log(1111111111, "成功了")
                this.isShowDownloadSuccess = true;
              }
            } catch (err) {
              const fileName = "故障项匹配数据.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
          this.codeLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.codeLoading = false;
        });
    },
    closebillDown() {
      this.isShowDownloadSuccess = false
    },
    billconfig() {
      this.isShowDownloadSuccess = false
      let routeData = this.$router.resolve({
        path: "/systemManage/downloadCenter",
      });
      window.open(routeData.href, "_blank");
    },
    //通过分类请求机型
    getlistSelected() {
      this.modelListData = []
      if (this.typeId) {
        _api.getlistSelected({
          "machineTypeId": this.typeId,
          brandId: this.brandNo ? this.brandNoListData.find(item => item.brandNo == this.brandNo)?.id : '',
          "name": ""
        }).then((res) => {
          if (res.code === 1) {
            this.modelListData = res.data;
          }
        });
      }
    },
    //回收分类选择
    recoverySeparator() {
      this.modelCode = ""
      this.getlistSelected()
    },
    // 获取状态下拉列表
    getStatusList() {
      _api.orderStatusList().then((res) => {
        let arr = [];
        for (const item of res.data) {
          arr.push({
            value: item.key,
            label: item.value,
          });
        }
        this.orderStatusList = arr;
      });
    },
        handleChange(value) {
      console.log(this.screenPhotos,"this.screenPhotos")
      let a = false
      let b = null
      if (this.selectedValues.length === 0) {
        this.screenPhotos = value
      }
      else {
        this.screenPhotos.forEach(item => {
          if (item[0] !== this.selectedValues[0][0]) {
            a = true
            b = item
          }
          else if (!item[1] && this.selectedValues[0][1]) {
            a = true
            b = item
          }
          else if ((!item[2] && this.selectedValues[0][2]) || (item[2] && this.selectedValues[0][2])) {
            a = true
            b = item
          }
        })
      }
      if (a) {
        this.screenPhotos = []
        this.screenPhotos.push(b)
      }
      this.selectedValues = this.screenPhotos
      console.log(this.selectedValues, "selectedValues")
      let lsarry = []
      let arry = []
      this.selectedValues.forEach(item => {
        if (item[0]) {
          arry.push(item[0])
        }
        if (item.length == 2) {
          lsarry.push(item[1])
        }
        if (item.length == 3) {
          lsarry.push(item[2])
        }
      })
      let lightScreenValidType = arry.reduce((acc, current) => {
        if (!acc.has(current)) {
          acc.add(current);
        }
        return acc;
      }, new Set());

      this.lightScreenValidType = Array.from(lightScreenValidType);
      this.lightScreenCompares = lsarry
      console.log(this.lightScreenCompares, "lightScreenCompares")
      console.log(this.lightScreenValidType, "lightScreenValidType")
    },
     handleChange1(value) {
      console.log(this.sku,"this.sku")
      console.log(this.selectedValues1,"this.selectedValues1")
      let a = false
      let b = null
      if (this.selectedValues1.length === 0) {
        this.sku = value
      }
      else {
        this.sku.forEach(item => {
          if (item[0] !== this.selectedValues1[0][0]) {
            a = true
            b = item
          }
          else if (!item[1] && this.selectedValues1[0][1]) {
            a = true
            b = item
          }
        })
      }
      if (a) {
        this.sku = []
        this.sku.push(b)
      }
      this.selectedValues1 = this.sku
      console.log(this.selectedValues1, "selectedValues1")
      let lsarry=[]
      let arry=[]
      this.selectedValues1.forEach(item => {
        if (item[0]) {
          arry.push(item[0])
        }
        if (item.length == 2) {
          lsarry.push(item[1])
        }
      })
      let modelCompareType = arry.reduce((acc, current) => {
        if (!acc.has(current)) {
          acc.add(current);
        }
        return acc;
      }, new Set());

      this.modelCompareType = Array.from(modelCompareType);
      this.modelPlatforms= lsarry
      console.log(this.modelPlatforms, "modelPlatforms")
      console.log(this.modelCompareType, "modelCompareType")
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  /deep/.el-select-dropdown {
    border-radius: 20px;
  }

  .select_down {
    /deep/.el-popper {
      border-radius: 20px;
    }

    /deep/.el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: #e4ecfd;
      color: rgba(9, 129, 255, 1);
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .time-type {
    /deep/.el-input__inner {
      border: none;
    }
  }
}

.cance-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}

.command {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
